import {BackendStatsByPostURL} from 'components/Backend/Stats/ByPortURL';

export default BackendStatsByPostURL;
export const orderNum = 6;
export const title = '帖子統計';
